import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getVehicleStockInventories,
  getVehicleStockInventory,
  createVehicleStockInventory,
  updateVehicleStockInventory,
  deleteVehicleStockInventory,
  getTrashedVehicleStockInventories,
  restoreVehicleStockInventory,
  forceDeleteVehicleStockInventory,
} from "api/vehicleStockInventoryApi"

import { useMutation, useQueryClient } from "@tanstack/react-query"

export const VEHICLE_STOCK_INVENTORY_QUERY_KEY = "vehicle-stock-inventories"

export const useVehicleStockInventories = (params = {}, enabled = true) =>
  usePaginatedResource(
    VEHICLE_STOCK_INVENTORY_QUERY_KEY,
    getVehicleStockInventories,
    params,
    enabled
  )

export const useVehicleStockInventory = (id, enabled = true) =>
  useResourceItem(
    VEHICLE_STOCK_INVENTORY_QUERY_KEY,
    getVehicleStockInventory,
    id,
    enabled
  )

export const useCreateVehicleStockInventory = () =>
  useCreateResource(createVehicleStockInventory, VEHICLE_STOCK_INVENTORY_QUERY_KEY)

export const useEditVehicleStockInventory = () =>
  useEditResource(updateVehicleStockInventory, VEHICLE_STOCK_INVENTORY_QUERY_KEY)

export const useDeleteVehicleStockInventory = () =>
  useDeleteResource(deleteVehicleStockInventory, VEHICLE_STOCK_INVENTORY_QUERY_KEY)

export const useTrashedVehicleStockInventories = (params = {}) =>
  usePaginatedResource(
    [VEHICLE_STOCK_INVENTORY_QUERY_KEY, "trashed"],
    getTrashedVehicleStockInventories,
    params,
    true
  )

export const useRestoreVehicleStockInventory = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreVehicleStockInventory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [VEHICLE_STOCK_INVENTORY_QUERY_KEY],
      })
    },
  })
}

export const useForceDeleteVehicleStockInventory = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: forceDeleteVehicleStockInventory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [VEHICLE_STOCK_INVENTORY_QUERY_KEY],
      })
    },
  })
}
